(function() {
    'use strict';

    angular
        .module('adjustBenApp')
        .controller('AdjustBenPendingDialogController', AdjustBenPendingDialogController);

    AdjustBenPendingDialogController.$inject = ['$scope', '$uibModalInstance','AdjustBenService','txnId','taskInstanceId','NgTableParams'];

    function AdjustBenPendingDialogController ($scope, $uibModalInstance,AdjustBenService,txnId,taskInstanceId,NgTableParams) {
    	var adjustBenPendingDial = this;
    	adjustBenPendingDial.data=[];
    	adjustBenPendingDial.pendingTypes=pendingTypes;
    	AdjustBenService.query({uri:'getListPending',txnNum:txnId},function(result){
    		if(result.length>0){
    		adjustBenPendingDial.dataOld=result;
    		adjustBenPendingDial.tableParams = new NgTableParams({
    			count: adjustBenPendingDial.dataOld.length // hides pager
	  	    }, {
	  	      counts: [], // hide page counts control
	  	      filterDelay: 0,
	  	      dataset: adjustBenPendingDial.dataOld
	  	    });
    		}
    	});
    	adjustBenPendingDial.deletePending = function (idx ) {
    		adjustBenPendingDial.tableParams.data.splice(idx, 1);
    		adjustBenPendingDial.data.splice(idx, 1);
    		adjustBenPendingDial.tableParams.reload();
		}
    	adjustBenPendingDial.addPending=function(){
    		var item;
    		var today = new Date();
    		var dd = today.getDate();
    		var mm = today.getMonth()+1; //January is 0!
    		var yyyy = today.getFullYear();
    		if(dd<10) {
    		    dd='0'+dd
    		} 

    		if(mm<10) {
    		    mm='0'+mm
    		} 

    		today = dd+'/'+mm+'/'+yyyy;
    		adjustBenPendingDial.benPendingDate = new Date();
	    	item={taskInstanceId:taskInstanceId,txnId:txnId,benPendingValue:adjustBenPendingDial.pendingTypes[0].valuePending,benPendingDate:today,benPendingRemark:""};
	    	adjustBenPendingDial.data.push(item);
	    	adjustBenPendingDial.tableParams = new NgTableParams({
	    		count: adjustBenPendingDial.data.length // hides pager
	  	    }, {
	  	      counts: [], // hide page counts control
	  	      filterDelay: 0,
	  	      dataset: adjustBenPendingDial.data
	  	    });
    	}
    	adjustBenPendingDial.ok= ok;
    	adjustBenPendingDial.cancel= cancel;
//    	adjustBenPendingDial.selected = {
//    	    item: adjustBenPendingDial.items[0]
//    	  };

    	  function ok() {
    		  AdjustBenService.post({uri:'doSaveProcess'},adjustBenPendingDial.tableParams.data, function(result) {
					 if(result){
						 $uibModalInstance.dismiss('cancel');
					 }
				}, function(error){
			});
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    }
})();
